import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus';
import locale from 'element-plus/lib/locale/lang/ja'
import 'element-plus/lib/theme-chalk/index.css';
import router from './router'

export const app = createApp(App)
app.config.globalProperties.api_path = 'https://pe.alliance-web.jp/tochigi/'
app.use(router).use(ElementPlus, {locale}).mount('#app')
